// @flow

type SingleColor = {
  name: string,
  value: string,
  pastel: string,
};
export function getPastelColor(value: string): string {
  const color = colorList.find(i => i.value === value);
  return color ? color.pastel : '#FFFFFF';
}

const colorList: SingleColor[] = [
  {
    name: 'Rosado',
    value: '#F45C80',
    pastel: '#FEF1F4',
  },
  {
    name: 'Azul',
    value: '#2F8EDF',
    pastel: '#EDF5FC',
  },
  {
    name: 'Morado',
    value: '#4E4E73',
    pastel: '#E7E7EE',
  },
  {
    name: 'Verde ',
    value: '#51D08B',
    pastel: '#D9ECE3',
  },
];
